(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tigmee-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  const header   = document.getElementById('site-header');
  const announce = document.querySelector('.tigmee-shell .announce');
  const spacer   = document.querySelector('.tg-header-spacer');

  /* Spacer mirrors actual header height so content starts at the right position */
  function syncSpacer() {
    if (header && spacer) spacer.style.height = header.offsetHeight + 'px';
  }
  syncSpacer();
  if (document.fonts) document.fonts.ready.then(syncSpacer);
  window.addEventListener('resize', syncSpacer, { passive: true });

  /* Header tracks the announce bar: slides flush with it as it scrolls away */
  function updateHeaderPos() {
    if (!header || !announce) return;
    var offset = Math.max(0, announce.offsetHeight - window.scrollY);
    header.style.transform = offset > 0 ? 'translateY(' + offset + 'px)' : '';
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  }
  updateHeaderPos();
  window.addEventListener('scroll', updateHeaderPos, { passive: true });

  const drawer = document.getElementById('drawer');
  const overlay = document.getElementById('overlay');
  const btnMenu = document.getElementById('btn-menu');
  const btnDrawerClose = document.getElementById('btn-drawer-close');
  const searchDrawer = document.getElementById('search-drawer');
  const btnSearch = document.getElementById('btn-search');
  const btnSearchClose = document.getElementById('btn-search-close');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function openSearch() {
    if (searchDrawer) searchDrawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    setTimeout(() => {
      const input = searchDrawer && searchDrawer.querySelector('input');
      if (input) input.focus();
    }, 200);
  }
  function closeSearch() {
    if (searchDrawer) searchDrawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
  }

  if (btnMenu) btnMenu.addEventListener('click', openDrawer);
  if (btnDrawerClose) btnDrawerClose.addEventListener('click', closeDrawer);
  if (btnSearch) btnSearch.addEventListener('click', openSearch);
  if (btnSearchClose) btnSearchClose.addEventListener('click', closeSearch);
  if (overlay) overlay.addEventListener('click', () => { closeDrawer(); closeSearch(); });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeDrawer(); closeSearch(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tigmee-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  /* --- Hero slider --------------------------------------------- */
  const slides = document.querySelectorAll('.hero__slide');
  const dots = document.querySelectorAll('.hero__dot');
  let currentSlide = 0;
  let slideTimer;

  function goToSlide(i) {
    slides.forEach(s => s.classList.remove('is-active'));
    dots.forEach(d => d.classList.remove('is-active'));
    currentSlide = (i + slides.length) % slides.length;
    slides[currentSlide].classList.add('is-active');
    dots[currentSlide].classList.add('is-active');
  }
  function nextSlide() { goToSlide(currentSlide + 1); }
  function prevSlide() { goToSlide(currentSlide - 1); }
  function startAutoplay() {
    clearInterval(slideTimer);
    slideTimer = setInterval(nextSlide, 6000);
  }
  document.getElementById('hero-next').addEventListener('click', () => { nextSlide(); startAutoplay(); });
  document.getElementById('hero-prev').addEventListener('click', () => { prevSlide(); startAutoplay(); });
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      goToSlide(parseInt(dot.dataset.slide, 10));
      startAutoplay();
    });
  });
  startAutoplay();

  /* --- Tabs ---------------------------------------------------- */
  const tabs = document.querySelectorAll('.tab');
  const panels = document.querySelectorAll('.tab-panel');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      tabs.forEach(t => t.classList.remove('is-active'));
      panels.forEach(p => p.classList.remove('is-active'));
      tab.classList.add('is-active');
      document.querySelector(`.tab-panel[data-panel="${target}"]`).classList.add('is-active');
    });
  });

  /* --- Arrow keys navigate hero slides -------------------------
     Mobile drawer + search drawer now live in the standalone
     tigmee-header section (rendered by the layout), which owns
     its own open/close/Escape handling independently. */
  document.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight') { nextSlide(); startAutoplay(); }
    if (e.key === 'ArrowLeft') { prevSlide(); startAutoplay(); }
  });

  /* --- Quick-add + wishlist toast ----------------------------- */
  document.querySelectorAll('.product__quick-add, .product__icon-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const orig = btn.textContent;
      if (btn.classList.contains('product__quick-add')) {
        btn.textContent = 'Added ✓';
        btn.style.background = 'var(--color-accent)';
        setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 1500);
        const badge = document.querySelector('.tg-header__icon-btn .badge');
        if (badge) badge.textContent = parseInt(badge.textContent, 10) + 1;
      } else {
        btn.style.background = 'var(--color-accent)';
        btn.style.color = '#fff';
        setTimeout(() => { btn.style.background = ''; btn.style.color = ''; }, 1200);
      }
    });
  });

  /* --- Reveal on scroll (progressive enhancement) ------------- */
  /* Only hide/reveal if IntersectionObserver is supported AND user
     hasn't requested reduced motion. Elements stay fully visible
     otherwise, so nothing is ever hidden from non-JS users.       */
  const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !prefersReduce) {
    const revealTargets = document.querySelectorAll('.product, .cat-card, .circle-item, .promo, .mosaic__item, .value, .usp, .section-heading');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    revealTargets.forEach((el, i) => {
      // Skip if already in viewport at load time — keep visible
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = `opacity .7s cubic-bezier(.25,.8,.35,1) ${(i % 8) * 60}ms, transform .7s cubic-bezier(.25,.8,.35,1) ${(i % 8) * 60}ms`;
      io.observe(el);
    });
  }

  /* --- Products slider arrows ---------------------------------- */
  const productsSlider = document.getElementById('products-slider');
  const productsPrev = document.getElementById('products-prev');
  const productsNext = document.getElementById('products-next');

  if (productsSlider && productsPrev && productsNext) {
    function scrollProducts(direction) {
      const firstCard = productsSlider.querySelector('.product');
      if (!firstCard) return;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(productsSlider).columnGap) || 20;
      const scrollBy = (cardWidth + gap) * (window.innerWidth > 900 ? 2 : 1);
      productsSlider.scrollBy({ left: direction * scrollBy, behavior: 'smooth' });
    }
    productsNext.addEventListener('click', () => scrollProducts(1));
    productsPrev.addEventListener('click', () => scrollProducts(-1));

    function updateArrowStates() {
      const maxScroll = productsSlider.scrollWidth - productsSlider.clientWidth;
      productsPrev.disabled = productsSlider.scrollLeft <= 2;
      productsNext.disabled = productsSlider.scrollLeft >= maxScroll - 2;
    }
    updateArrowStates();
    productsSlider.addEventListener('scroll', updateArrowStates, { passive: true });
    window.addEventListener('resize', updateArrowStates);
  }

  /* --- Categories slider arrows -------------------------------- */
  const catsSlider = document.getElementById('cats-slider');
  const catsPrev = document.getElementById('cats-prev');
  const catsNext = document.getElementById('cats-next');

  if (catsSlider && catsPrev && catsNext) {
    function scrollCats(direction) {
      const firstCard = catsSlider.querySelector('.cat-card');
      if (!firstCard) return;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(catsSlider).columnGap) || 20;
      const scrollBy = (cardWidth + gap) * (window.innerWidth > 900 ? 2 : 1);
      catsSlider.scrollBy({ left: direction * scrollBy, behavior: 'smooth' });
    }
    catsNext.addEventListener('click', () => scrollCats(1));
    catsPrev.addEventListener('click', () => scrollCats(-1));

    function updateCatsArrowStates() {
      const maxScroll = catsSlider.scrollWidth - catsSlider.clientWidth;
      catsPrev.disabled = catsSlider.scrollLeft <= 2;
      catsNext.disabled = catsSlider.scrollLeft >= maxScroll - 2;
    }
    updateCatsArrowStates();
    catsSlider.addEventListener('scroll', updateCatsArrowStates, { passive: true });
    window.addEventListener('resize', updateCatsArrowStates);
  }

  /* --- Before / After slider ---------------------------------- */
  const baSlider = document.getElementById('ba-slider');
  if (baSlider) {
    const baAfterWrap = document.getElementById('ba-after-wrap');
    const baHandle    = document.getElementById('ba-handle');
    let isDragging = false;

    const baArrows = document.getElementById('ba-arrows');
    function setPosition(x) {
      const rect = baSlider.getBoundingClientRect();
      let pct = (x - rect.left) / rect.width;
      pct = Math.min(Math.max(pct, 0.02), 0.98);
      const pctPx = (pct * 100).toFixed(2) + '%';
      baAfterWrap.style.width = pctPx;
      baHandle.style.left     = pctPx;
      if (baArrows) baArrows.style.left = pctPx;
      // Keep after image at full container width so it doesn't squish
      baAfterWrap.querySelector('.ba-slider__img').style.width = baSlider.offsetWidth + 'px';
    }

    // Init at 50% — defer until after paint so offsetWidth is correct
    requestAnimationFrame(() => {
      const rect = baSlider.getBoundingClientRect();
      setPosition(rect.left + rect.width * 0.5);
    });

    /* Hint animation: plays once when section enters viewport */
    function runHint() {
      if (isDragging) return;
      var stops = [0.50, 0.30, 0.70, 0.50];
      var segMs  = [500, 500, 400];
      var total  = 1400;
      var start  = performance.now();
      function ease(t) { return t < 0.5 ? 2*t*t : -1+(4-2*t)*t; }
      (function frame(now) {
        if (isDragging) return;
        var elapsed = Math.min(now - start, total);
        var cum = 0, pct = stops[0];
        for (var i = 0; i < segMs.length; i++) {
          if (elapsed <= cum + segMs[i]) {
            var t = ease((elapsed - cum) / segMs[i]);
            pct = stops[i] + (stops[i+1] - stops[i]) * t;
            break;
          }
          cum += segMs[i];
          pct = stops[i+1];
        }
        var p = (pct * 100).toFixed(2) + '%';
        baAfterWrap.style.width = p;
        baHandle.style.left = p;
        if (baArrows) baArrows.style.left = p;
        baAfterWrap.querySelector('.ba-slider__img').style.width = baSlider.offsetWidth + 'px';
        if (elapsed < total) requestAnimationFrame(frame);
      })(start);
    }
    if ('IntersectionObserver' in window) {
      var hintObs = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) { setTimeout(runHint, 350); hintObs.disconnect(); }
      }, { threshold: 0.4 });
      hintObs.observe(baSlider);
    }

    baSlider.addEventListener('mousedown', e => { isDragging = true; setPosition(e.clientX); });
    window.addEventListener('mousemove',  e => { if (isDragging) setPosition(e.clientX); });
    window.addEventListener('mouseup',    () => { isDragging = false; });

    baSlider.addEventListener('touchstart', e => { isDragging = true; setPosition(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchmove',   e => { if (isDragging) setPosition(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchend',    () => { isDragging = false; });

    window.addEventListener('resize', () => {
      baAfterWrap.querySelector('.ba-slider__img').style.width = baSlider.offsetWidth + 'px';
    });
  }

})();

  } catch(e) { console.error(e); }
})();
})();
